import { CHATROOM_REALTIME_EVENT } from '../../Chatroom.constants'

function getChatroomRealtimeEvent(ctx) {
  return ctx?.data?.event
}

export function getChatroomRealtimePayloadUuid(ctx) {
  return ctx?.data?.payload?.uuid || null
}

export function isChatroomRealtimeMessageCreated(ctx) {
  return (
    getChatroomRealtimeEvent(ctx) === CHATROOM_REALTIME_EVENT.MessageCreated
  )
}

export function isChatroomRealtimeMessageDeleted(ctx) {
  return (
    getChatroomRealtimeEvent(ctx) === CHATROOM_REALTIME_EVENT.MessageDeleted
  )
}

export function isChatroomRealtimeMessageUpdated(ctx) {
  return (
    getChatroomRealtimeEvent(ctx) === CHATROOM_REALTIME_EVENT.MessageUpdated
  )
}
